<div class="progress-loader">
    <mat-progress-spinner [mode]="'indeterminate'" diameter="30"></mat-progress-spinner>
</div>